import { useQuery } from "react-query";
import { getCameraType2List } from "../../../../../actions/Utilities/CameraType2";

export default function useGetCameraType2List() {
  return useQuery("GetCameraType2", getCameraType2List, {
    refetchOnWindowFocus: false,
  });
}
